import { render } from "./SuggestedAmounts.vue?vue&type=template&id=383af297&scoped=true"
import script from "./SuggestedAmounts.vue?vue&type=script&lang=js"
export * from "./SuggestedAmounts.vue?vue&type=script&lang=js"

import "./SuggestedAmounts.vue?vue&type=style&index=0&id=383af297&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383af297"]])

export default __exports__